import { ProviderCustomersCard } from "../../provider-bookings/ProviderCustomersCard";

export function CustomersSection() {
  return (
    <div className="grid gap-4">
      <ProviderCustomersCard />
    </div>
  );
}
